
import React, { useEffect, useState } from 'react';

import { ToastContainer, toast } from "react-toastify";
import { getAllArea, saveYoutubeVideo, saveconstituencydevelopments, updateYoutubeVideo, updateconstituencydevelopments } from '../../../../services/CommonService';
import { Accordion } from 'react-bootstrap';
import FileBase64 from 'react-file-base64';
import ReactQuill from 'react-quill';





const AddConstituencyDevelopments = ({ tenantprop, updateprop, areaprops }) => {


    const modules = {
        toolbar: [
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ["bold", "italic", "underline", "strike", "blockquote"],
            [{ size: [] }],
            [{ font: [] }],
            [{ align: ["right", "center", "justify"] }],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link", "image"],
            [{ color: ["red", "#785412"] }],
            [{ background: ["red", "#785412"] }]
        ]
    };

    const formats = [
        "header",
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "list",
        "bullet",
        "link",
        "color",
        "image",
        "background",
        "align",
        "size",
        "font"
    ];
    const notifyTopFullWidth = (message) => {
        toast.info(message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    };
    const fields = {
        name: '',
        status: '',
        tenantid: tenantprop.tenantid,
        tenant: tenantprop,
        subapplicationid: '',
        subapplicationname: '',
        image: '',
        videourl: '',
        description: '',


    }


    const errors = {
        name: '',
        position: '',
        status: '',

    }

    const [errorFields, setErrorFields] = useState(errors);
    const [formfields, setFromFields] = useState(fields);
    const [showarea, setShowArea] = useState(false);
    const [strtype, setStrType] = useState([]);
    const [filefields, setFileFields] = useState(null);
    const [imageshow, setImageshow] = useState(null);
    const [percent, setPercent] = useState(50);
     const [value, setValue] = useState('');

    useEffect(() => {
        getstrTypes(tenantprop.type);
        setFieldData();


    }, []);



    const { name, position, status, subapplicationid, videourl } = formfields;

    const setFieldData = async () => {
        if (updateprop?.id) {
            setFromFields(updateprop);
            setFileFields(updateprop.image);
            setImageshow(true);
            setValue(updateprop.description)

        }
        if (areaprops?.id) {
            setShowArea(true);
        }
    }

    const getstrTypes = async (type) => {
        let reqparams = {};
        if (type == 'political') {
            reqparams = {
                pageno: '-1',
                query: { status: 'Active', strtype: 'Constituency' }
            }
        }
        else if (type == 'educational') {
            reqparams = {
                pageno: '-1',
                query: { status: 'Active', strtype: 'College' }
            }
        }

        const reqDATA = await getAllArea(reqparams);
        setStrType(reqDATA.data);

    }


    const validateForm = async () => {
        let fields = formfields;
        let errors = {};
        let formIsValid = true;

        if (!fields["name"]) {
            formIsValid = false;
            errors["name"] = "*Please enter video url .";
        }
        if (!fields["status"]) {
            formIsValid = false;
            errors["status"] = "*Please select status .";
        }


        setErrorFields(errors)
        return formIsValid;

    }

    const submitForm = async () => {
       
        const isValid = await validateForm();
        if (isValid) {
            const strtypdata = strtype.filter(t => t.id == formfields.subapplicationid);
            formfields.subapplicationname = strtypdata[0]?.name;
            formfields.image = filefields;
            formfields.description=value
            if (!formfields.id) {
                console.log("formfields",formfields);
                //save

                const Response = await saveconstituencydevelopments(formfields);
                if (Response.data.id) {
                    notifyTopFullWidth("Data saved successfully");
                    formfields.id = Response.data.id;
                }

            } else {
                //update

                const Response = await updateconstituencydevelopments(formfields);
                if (Response.data.id) {
                    notifyTopFullWidth("Data updated successfully");
                    formfields.id = Response.data.id;
                }
            }

        }
    }

    function handleChangeFile(files) {
        console.log(files);
        setFileFields(files[0]);
        if (files[0].type === 'image/png' || files[0].type === 'image/jpeg' || files[0].type === 'image/jpg') {
            let sz = files[0].size.split(' ');
            if (sz[0] > 200) {
                toast('File size should be below 200 kb', {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } else {
                setFileFields(files[0].base64);
                //setImageShow(files[0].base64);
                setImageshow(true);
            }
        } else {
            toast('Please upload only png or jpg', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
        //setFile(event.target.files[0])
    }

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFromFields((prevState) => ({
            ...prevState,
            [name]: value
        }));

    }

    const handleProcedureContentChange = (content, delta, source, editor) => {
        setValue(content);
        //let has_attribues = delta.ops[1].attributes || "";
        //console.log(has_attribues);
        //const cursorPosition = e.quill.getSelection().index;
        // this.quill.insertText(cursorPosition, "★");
        //this.quill.setSelection(cursorPosition + 1);
    };

    return (<>
        <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
        />
        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Tenant Name
            </label>
            <div className="col-lg-6">
                <b> {tenantprop.name} </b>

            </div>
        </div>
        <br />

        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Constituency
            </label>
            <div className="col-lg-6">
                <select className="form-control" name="subapplicationid"
                    value={subapplicationid} onChange={handleChange}>
                    <option value=''>Select </option>
                    {strtype.map(item => (
                        <option
                            key={item.id}
                            value={item.id}
                        >
                            {item.name}
                        </option>
                    ))}
                </select>

            </div>

        </div>

        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Name
            </label>
            <div className="col-lg-6">
                <input component="input"
                    placeholder="Name"
                    name="name"
                    className="form-control"

                    value={name} maxLength={200} onChange={handleChange} />

            </div>
            <div className="errorMsg">{errorFields.name}</div>
        </div>

        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Video url
            </label>
            <div className="col-lg-6">
                <input component="input"
                    placeholder="Videourl"
                    name="videourl"
                    className="form-control"

                    value={videourl} maxLength={50} onChange={handleChange} />

            </div>
        </div>


        <div className="form-group mb-3 row">
            <label
                className="col-lg-4 col-form-label"
                htmlFor="val-username"
            >
                Status
            </label>
            <div className="col-lg-6">
                <select
                    className="form-control" name='status'
                    onChange={handleChange} value={status}>
                    <option value="">Select Status</option>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                </select>

            </div>
            <div className="errorMsg">{errorFields.status}</div>
        </div>

        <Accordion className="accordion accordion-danger-solid" defaultActiveKey="0">
            <Accordion.Item key={percent} eventKey={`${percent}`}>
                <Accordion.Header className="accordion-header">
                    Image
                </Accordion.Header>
                <Accordion.Collapse eventKey={`${percent}`} className="accordion__body">
                    <div className="accordion-body">

                        <div className="form-group mb-3 row">
                            <label
                                className="col-lg-4 col-form-label"
                                htmlFor="val-username"
                            >
                                Display Image
                            </label>
                            <div className="custom-file">
                                <FileBase64
                                    multiple={true}
                                    onDone={handleChangeFile} />
                            </div>
                        </div>

                        {imageshow && <> <div className="form-group mb-3 row">
                            <label
                                className="col-lg-4 col-form-label"
                                htmlFor="val-username"
                            >
                                Uploaded Image
                            </label>
                            <img src={filefields} alt="Red dot" />

                        </div> </>}

                    </div>
                </Accordion.Collapse>
            </Accordion.Item>

        </Accordion>
        <Accordion className="accordion accordion-danger-solid" defaultActiveKey="0">
            <Accordion.Item key={percent} eventKey={`${percent}`}>
                <Accordion.Header className="accordion-header">
                    Description
                </Accordion.Header>
                <Accordion.Collapse eventKey={`${percent}`} className="accordion__body">
                    <div className="accordion-body">
                        <ReactQuill
                            theme="snow"
                            modules={modules}
                            formats={formats}
                            value={value}
                            onChange={handleProcedureContentChange}
                        />
                    </div>
                </Accordion.Collapse>
            </Accordion.Item>

        </Accordion>



        <br />
        <div className="form-group">
            <button onClick={submitForm} className="btn btn-primary" type="button"
            >Save</button>
        </div>

    </>)

}

export default AddConstituencyDevelopments